export const getGovernanceSummaryFromCompany = (company) => {
  let governanceSummary = null;
  const { articlesOfAssociation } = company;
  const templateVersions = articlesOfAssociation?.template?.versions ?? [];
  // Filter out draft versions and sort by versionNumber in descending order
  const nonDraftVersions = templateVersions
    .filter((version) => version.status !== "Draft")
    .sort((a, b) => {
      const versionA = parseFloat(a.versionNumber);
      const versionB = parseFloat(b.versionNumber);
      return versionB - versionA;
    });

  const latestTemplateVersion = nonDraftVersions[0] || {};

  if (latestTemplateVersion) {
    const { summary } = latestTemplateVersion;
    governanceSummary = summary;
  }
  return governanceSummary;
};

export const checkIfDirectorsMeetThresholdAsPerTheGovernanceSummary = (
  totalNumberOfDirectors,
  company
) => {
  const governanceSummary = getGovernanceSummaryFromCompany(company);
  if (governanceSummary) {
    const { directorsLimit } = governanceSummary;
    return totalNumberOfDirectors >= directorsLimit.minimum;
  } else {
    return "No summary present";
  }
};

export const directorApprovals = (
  totaldirectorsWhoHaveApproved,
  company,
  companyOfficials
) => {
  const directors = companyOfficials.filter(
    (official) =>
      official.designation === "Director" ||
      official.designation === "Director Shareholder"
  );

  const governanceSummary = getGovernanceSummaryFromCompany(company);
  if (governanceSummary) {
    const { resolutionApprovalSignatories } = governanceSummary;
    const { value } = resolutionApprovalSignatories;

    if (value === "All")
      return directors.length === totaldirectorsWhoHaveApproved?.length;
    if (value === "MAJORITY") {
      return totaldirectorsWhoHaveApproved > directors.length / 2;
    }
    return totaldirectorsWhoHaveApproved >= parseInt(value);
  } else {
    return "No summary present";
  }
};
export const shareholerApprovals = (
  shareholdersWhoHaveApproved,
  company,
  companyOfficials
) => {
  const shareholders = companyOfficials.filter(
    (official) =>
      official.designation === "Shareholder" ||
      official.designation === "Director Shareholder" ||
      official.designation === "Joint Shareholder"
  );

  const governanceSummary = getGovernanceSummaryFromCompany(company);
  if (governanceSummary) {
    const { approvalRequirementForWrittenResolutions } = governanceSummary;
    const { value } = approvalRequirementForWrittenResolutions;
    if (value === "All")
      return shareholders.length === shareholdersWhoHaveApproved?.length;
    if (value === "Majority") {
      const totalVotingRights = shareholders.reduce((acc, shareholder) => {
        const shareholderVotingRights = shareholder.sharesAllotted.reduce(
          (sum, share) => sum + (share.votingRights || 0),
          0
        );
        return acc + shareholderVotingRights;
      }, 0);

      const totalApprovedVotingRights = shareholdersWhoHaveApproved.reduce(
        (acc, sharehldr) => {
          const shareholder = shareholders.find(
            (sh) => sh.electronicAddress.email === sharehldr.email
          );
          if (!shareholder) return acc;
          return (
            acc +
            shareholder.sharesAllotted.reduce(
              (sum, share) => sum + (share.votingRights || 0),
              0
            )
          );
        },
        0
      );
      return totalApprovedVotingRights > totalVotingRights / 2;
    }
  } else {
    return "No summary present";
  }
};
